export default {
    // 中
    zhCN: {
        serial_no: '序号',
        username: '用户名',
        name: '姓名',
        organization: '组织',
        sex: '性别',
        phone_number: '手机号',
        email: '邮箱',
        role: '角色',
        login_time: '启用状态',
        password: '密码',
        user_edit: '用户编辑',
        service_provider_name: '服务商名称',
        import_snw_users: '导入snw用户',
        export_snw_users: '导出snw用户',
        brand: '品牌',
        enable: '启用',
        disable: '禁用',
        userName: '用户姓名',
        validity_period: '有效期',
        mailbox_reset: '邮箱重置',
        new_email: '新邮箱',
        remaining_validity_period: '剩余有效期',
        permanently_valid: '永久有效',
        fileName: '文件名称',
        creation_time: '创建时间',
        taskStatus: '任务状态',
        password_rules: '密码规则',
        min_length: '密码最小长度 8 位',
        max_length: '密码最大长度 20 位',
        validity_maxperiod: '有效期 90 天',
        require_special_char: '必须包含1位特殊字符',
        require_uppercase: '至少包含 1 个大写字母',
        require_lowercase: '至少包含 1 个小写字母',
        require_digit: '至少包含 1 个数字',
        no_spaces_allowed: '不允许包含空格',
        username_not_allowed: '不允许包含用户名',
        not_match_last_n_passwords: '不允许和前 6 次密码重复',
        allowed_special_characters: '允许使用的特殊字符',
    },
    // 英
    enUS: {
        serial_no: 'Serial number',
        username: 'User name',
        name: 'Name',
        organization: 'Organization',
        sex: 'Gender',
        phone_number: 'Phone number',
        email: 'Email',
        role: 'Role',
        login_time: 'Enable status',
        password: 'Password',
        user_edit: 'User edit',
        service_provider_name: 'Service provider name',
        import_snw_users: 'Import snw users',
        export_snw_users: 'Export snw users',
        brand: 'Brand',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'File Name',
        creation_time: 'Creation Time',
        taskStatus: 'Task Status',
        password_rules: 'Password rules',
        min_length: 'Minimum password length: 8 bits',
        max_length: 'Maximum password length: 20 bits',
        validity_maxperiod: 'Valid for 90 days',
        require_special_char: 'Must contain at least one special character.',
        require_uppercase: 'Contain at least 1 uppercase letter',
        require_lowercase: 'Contain at least 1 lowercase number',
        require_digit: 'Contain at least 1 number',
        no_spaces_allowed: 'No space is allowed',
        username_not_allowed: 'No Username is allowed',
        not_match_last_n_passwords: 'Cannot be duplicated with previous 6 Password',
        allowed_special_characters: 'Special characters allowed',
    },
    // 德
    deDE: {
        serial_no: 'Nr.',
        username: 'Benutzername',
        name: 'Name',
        organization: 'Organisation',
        sex: 'Geschlecht',
        phone_number: 'Telefonnummer',
        email: 'E-Mail',
        role: 'Rolle',
        login_time: 'Status aktivieren',
        password: 'Passwort',
        user_edit: 'Benutzer bearbeiten',
        service_provider_name: 'Name des Dienstleisters',
        import_snw_users: 'Snw-benutzer importieren',
        export_snw_users: 'Snw-benutzer exportieren',
        brand: 'Marke',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Dateiname',
        creation_time: 'Erstellungszeit',
        taskStatus: 'Aufgabenstatus',
        password_rules: 'Passwortregeln',
        min_length: 'Mindestlänge des Passworts: 8 Zeichen',
        max_length: 'Maximale Länge des Passworts: 20 Zeichen',
        validity_maxperiod: 'Gültigkeitsdauer: 90 Tage',
        require_special_char: 'Muss mindestens ein Sonderzeichen enthalten',
        require_uppercase: 'Muss mindestens einen Großbuchstaben enthalten',
        require_lowercase: 'Muss mindestens einen Kleinbuchstaben enthalten',
        require_digit: 'Muss mindestens eine Ziffer enthalten',
        no_spaces_allowed: 'Leerzeichen sind nicht erlaubt',
        username_not_allowed: 'Darf den Benutzernamen nicht enthalten',
        not_match_last_n_passwords: 'Darf nicht mit einem der letzten 6 Passwörter übereinstimmen',
        allowed_special_characters: 'Erlaubte Sonderzeichen',
    },
    // 法
    frFR: {
        serial_no: 'No',
        username: 'Nom d\'utilisateur',
        name: 'Nom',
        organization: 'Organisation',
        sex: 'Genre',
        phone_number: 'Numéro de téléphone',
        email: 'E-mail',
        role: 'Rôle',
        login_time: 'Statut actif',
        password: 'Mot de passe',
        user_edit: 'Modifier l\'utilisateur',
        service_provider_name: 'Nom du prestataire',
        import_snw_users: 'Importer un utilisateur snw',
        export_snw_users: 'Exporter un utilisateur snw',
        brand: 'Marque',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Nom du fichier',
        creation_time: 'Date de création',
        taskStatus: 'État de la tâche',
        password_rules: 'Règles du mot de passe',
        min_length: 'Longueur minimale du mot de passe : 8 caractères',
        max_length: 'Longueur maximale du mot de passe : 20 caractères',
        validity_maxperiod: 'Durée de validité : 90 jours',
        require_special_char: 'Doit contenir au moins un caractère spécial',
        require_uppercase: 'Doit contenir au moins une lettre majuscule',
        require_lowercase: 'Doit contenir au moins une lettre minuscule',
        require_digit: 'Doit contenir au moins un chiffre',
        no_spaces_allowed: 'Les espaces ne sont pas autorisés',
        username_not_allowed: 'Ne doit pas contenir le nom d’utilisateur',
        not_match_last_n_passwords:
            'Ne doit pas correspondre aux 6 derniers mots de passe utilisés',
        allowed_special_characters: 'Caractères spéciaux autorisés',
    },
    // 意大利
    itIT: {
        serial_no: 'No',
        username: 'Nome Utente',
        name: 'Nome',
        organization: 'Organizzazione',
        sex: 'Sesso',
        phone_number: 'Numero di Telefono',
        email: 'Email',
        role: 'Ruolo',
        login_time: 'Abilita stato',
        password: 'Password',
        user_edit: 'Modifica Utente',
        service_provider_name: 'Nome del fornitore di servizi',
        import_snw_users: 'Importa utenti snw',
        export_snw_users: 'Esporta utenti snw',
        brand: 'Marca',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Nome del file',
        creation_time: 'Data di creazione',
        taskStatus: 'Stato del compito',
        password_rules: 'Regole password',
        min_length: 'Lunghezza minima password: 8 caratteri',
        max_length: 'Lunghezza massima password: 20 caratteri',
        validity_maxperiod: 'Validità: 90 giorni',
        require_special_char: 'Deve contenere almeno un carattere speciale',
        require_uppercase: 'Deve contenere almeno una lettera maiuscola',
        require_lowercase: 'Deve contenere almeno una lettera minuscola',
        require_digit: 'Deve contenere almeno una cifra',
        no_spaces_allowed: 'Gli spazi non sono consentiti',
        username_not_allowed: 'Non deve contenere il nome utente',
        not_match_last_n_passwords: 'Non deve coincidere con una delle ultime 6 password',
        allowed_special_characters: 'Caratteri speciali consentiti',
    },
    // 荷兰
    nlNL: {
        serial_no: 'Nr.',
        username: 'Gebruikersnaam',
        name: 'Naam',
        organization: 'organisatie',
        sex: 'Geslacht',
        phone_number: 'Telefoonnummer',
        email: 'E-mail',
        role: 'Rol',
        login_time: 'Status inschakelen',
        password: 'Wachtwoord',
        user_edit: 'Gebruiker bewerken',
        service_provider_name: 'Naam dienstverlener',
        import_snw_users: 'Snw-gebruikers importeren',
        export_snw_users: 'Snw-gebruikers exporteren',
        brand: 'Merk',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Bestandsnaam',
        creation_time: 'Aanmaaktijd',
        taskStatus: 'Taakstatus',
        password_rules: 'Wachtwoordregels',
        min_length: 'Minimale wachtwoordlengte: 8 tekens',
        max_length: 'Maximale wachtwoordlengte: 20 tekens',
        validity_maxperiod: 'Geldigheidsduur: 90 dagen',
        require_special_char: 'Moet ten minste één speciaal teken bevatten',
        require_uppercase: 'Moet ten minste één hoofdletter bevatten',
        require_lowercase: 'Moet ten minste één kleine letter bevatten',
        require_digit: 'Moet ten minste één cijfer bevatten',
        no_spaces_allowed: 'Spaties zijn niet toegestaan',
        username_not_allowed: 'Mag de gebruikersnaam niet bevatten',
        not_match_last_n_passwords: 'Mag niet overeenkomen met een van de laatste 6 wachtwoorden',
        allowed_special_characters: 'Toegestane speciale tekens',
    },
    // 越南
    viVN: {
        serial_no: 'Số sê-ri',
        username: 'Tên người dùng',
        name: 'Tên',
        organization: 'Lịch',
        sex: 'Giới tính',
        phone_number: 'Số điện thoại',
        email: 'Email',
        role: 'Vai trò',
        login_time: 'Trạng thái kích hoạt',
        password: 'Mật khẩu',
        user_edit: 'Chỉnh sửa người dùng',
        service_provider_name: 'Tên nhà cung cấp dịch vụ',
        import_snw_users: 'Nhập người dùng snw',
        export_snw_users: 'Xuất người dùng snw',
        brand: 'Thương hiệu',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Tên tệp',
        creation_time: 'Thời gian tạo',
        taskStatus: 'Trạng thái nhiệm vụ',
        password_rules: 'Quy tắc mật khẩu',
        min_length: 'Độ dài tối thiểu của mật khẩu: 8 ký tự',
        max_length: 'Độ dài tối đa của mật khẩu: 20 ký tự',
        validity_maxperiod: 'Thời hạn hiệu lực: 90 ngày',
        require_special_char: 'Phải chứa ít nhất 1 ký tự đặc biệt',
        require_uppercase: 'Phải chứa ít nhất 1 chữ in hoa',
        require_lowercase: 'Phải chứa ít nhất 1 chữ thường',
        require_digit: 'Phải chứa ít nhất 1 chữ số',
        no_spaces_allowed: 'Không được chứa khoảng trắng',
        username_not_allowed: 'Không được chứa tên người dùng',
        not_match_last_n_passwords: 'Không được trùng với 6 mật khẩu gần nhất',
        allowed_special_characters: 'Các ký tự đặc biệt được phép',
    },
    // 西班牙
    esES: {
        serial_no: 'Núm. de serie',
        username: 'Nombre de usuario',
        name: 'Nombre',
        organization: 'Organización',
        sex: 'Género',
        phone_number: 'Número de teléfono',
        email: 'Correo electrónico',
        role: 'Rol',
        login_time: 'Estado de activación',
        password: 'Contraseña',
        user_edit: 'Editar usuario',
        service_provider_name: 'Nombre del proveedor de servicios',
        import_snw_users: 'Importar usuarios de snw',
        export_snw_users: 'Exportar usuarios de snw',
        brand: 'Marca',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Nombre del archivo',
        creation_time: 'Fecha de creación',
        taskStatus: 'Estado de la tarea',
        password_rules: 'Reglas de contraseña',
        min_length: 'Longitud mínima de la contraseña: 8 caracteres',
        max_length: 'Longitud máxima de la contraseña: 20 caracteres',
        validity_maxperiod: 'Validez: 90 días',
        require_special_char: 'Debe contener al menos un carácter especial',
        require_uppercase: 'Debe contener al menos una letra mayúscula',
        require_lowercase: 'Debe contener al menos una letra minúscula',
        require_digit: 'Debe contener al menos un dígito',
        no_spaces_allowed: 'No se permiten espacios',
        username_not_allowed: 'No debe contener el nombre de usuario',
        not_match_last_n_passwords: 'No debe coincidir con ninguna de las últimas 6 contraseñas',
        allowed_special_characters: 'Caracteres especiales permitidos',
    },
    // 葡萄牙
    ptBR: {
        serial_no: 'Número de série',
        username: 'Nome de usuário',
        name: 'Nome',
        organization: 'Organização',
        sex: 'Sexo',
        phone_number: 'Número de telefone',
        email: 'E-mail',
        role: 'Função',
        login_time: 'Tempo de login',
        password: 'Senha',
        user_edit: 'Editar usuário',
        service_provider_name: 'Nome do provedor de serviços',
        import_snw_users: 'Importar usuários SNW',
        export_snw_users: 'Exportar usuários SNW',
        brand: 'Marca',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Nome do arquivo',
        creation_time: 'Data de criação',
        taskStatus: 'Status da tarefa',
        password_rules: 'Regras da palavra-passe',
        min_length: 'Comprimento mínimo da palavra-passe: 8 caracteres',
        max_length: 'Comprimento máximo da palavra-passe: 20 caracteres',
        validity_maxperiod: 'Validade: 90 dias',
        require_special_char: 'Deve conter pelo menos um carácter especial',
        require_uppercase: 'Deve conter pelo menos uma letra maiúscula',
        require_lowercase: 'Deve conter pelo menos uma letra minúscula',
        require_digit: 'Deve conter pelo menos um dígito',
        no_spaces_allowed: 'Espaços não são permitidos',
        username_not_allowed: 'Não pode conter o nome de utilizador',
        not_match_last_n_passwords:
            'Não pode ser igual a qualquer uma das últimas 6 palavras-passe',
        allowed_special_characters: 'Caracteres especiais permitidos',
    },
    // 波兰
    plPL: {
        serial_no: 'Numer seryjny',
        username: 'Nazwa użytkownika',
        name: 'Imię i nazwisko',
        organization: 'Organizacja',
        sex: 'Płeć',
        phone_number: 'Numer telefonu',
        email: 'Email',
        role: 'Rola',
        login_time: 'status aktywcji',
        password: 'Hasło',
        user_edit: 'Edycja użytkownika',
        service_provider_name: 'Nazwa usługodawcy',
        import_snw_users: 'Importuj użytkowników SNW',
        export_snw_users: 'Eksportuj użytkowników SNW',
        brand: 'Marka',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Nazwa pliku',
        creation_time: 'Czas utworzenia',
        taskStatus: 'Status zadania',
        password_rules: 'Zasady hasła',
        min_length: 'Minimalna długość hasła: 8 znaków',
        max_length: 'Maksymalna długość hasła: 20 znaków',
        validity_maxperiod: 'Okres ważności: 90 dni',
        require_special_char: 'Musi zawierać co najmniej jeden znak specjalny',
        require_uppercase: 'Musi zawierać co najmniej jedną wielką literę',
        require_lowercase: 'Musi zawierać co najmniej jedną małą literę',
        require_digit: 'Musi zawierać co najmniej jedną cyfrę',
        no_spaces_allowed: 'Spacje są niedozwolone',
        username_not_allowed: 'Nie może zawierać nazwy użytkownika',
        not_match_last_n_passwords: 'Nie może powtarzać żadnego z ostatnich 6 haseł',
        allowed_special_characters: 'Dozwolone znaki specjalne',
    },
    // 土耳其
    trTR: {
        serial_no: 'Nr',
        username: ' Kullanıcı adı',
        name: 'İsim',
        organization: 'Düzenleme',
        sex: 'Cinsiyet',
        phone_number: 'Telefon numarası',
        email: 'E-posta',
        role: 'Rol',
        login_time: 'Etkin durum',
        password: 'Parola',
        user_edit: 'Kullanıcıyı Düzenle',
        service_provider_name: 'Hizmet verici adı',
        import_snw_users: 'İçeri snw kullanıcı',
        export_snw_users: 'türev snw kullanıcı',
        brand: 'Marka',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Dosya adı',
        creation_time: 'Oluşturulma zamanı',
        taskStatus: 'Görev durumu',
        password_rules: 'Şifre kuralları',
        min_length: 'Şifre en az 8 karakter olmalıdır',
        max_length: 'Şifre en fazla 20 karakter olabilir',
        validity_maxperiod: 'Geçerlilik süresi: 90 gün',
        require_special_char: 'En az bir özel karakter içermelidir',
        require_uppercase: 'En az bir büyük harf içermelidir',
        require_lowercase: 'En az bir küçük harf içermelidir',
        require_digit: 'En az bir rakam içermelidir',
        no_spaces_allowed: 'Boşluk içeremez',
        username_not_allowed: 'Kullanıcı adını içeremez',
        not_match_last_n_passwords: 'Son 6 şifreden hiçbirine benzememelidir',
        allowed_special_characters: 'İzin verilen özel karakterler',
    },
    // 捷克语
    csCZ: {
        serial_no: 'Sériové číslo',
        username: 'Uživatelské jméno',
        name: 'Název',
        organization: 'Organizace',
        sex: 'Pohlaví',
        phone_number: 'Telefonní číslo',
        email: 'E-mailem',
        role: 'Role',
        login_time: 'Povolit stav',
        password: 'Heslo',
        user_edit: 'Úprav uživatele',
        service_provider_name: 'Jméno poskytovatele služeb',
        import_snw_users: 'Importujte uživatele snw',
        export_snw_users: 'Exportujte uživatele snw',
        brand: 'značka',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Název souboru',
        creation_time: 'Čas vytvoření',
        taskStatus: 'Stav úkolu',
        password_rules: 'Pravidla hesla',
        min_length: 'Minimální délka hesla: 8 znaků',
        max_length: 'Maximální délka hesla: 20 znaků',
        validity_maxperiod: 'Platnost: 90 dnů',
        require_special_char: 'Musí obsahovat alespoň jeden speciální znak',
        require_uppercase: 'Musí obsahovat alespoň jedno velké písmeno',
        require_lowercase: 'Musí obsahovat alespoň jedno malé písmeno',
        require_digit: 'Musí obsahovat alespoň jednu číslici',
        no_spaces_allowed: 'Mezery nejsou povoleny',
        username_not_allowed: 'Nesmí obsahovat uživatelské jméno',
        not_match_last_n_passwords: 'Nesmí být shodné s žádným z posledních 6 hesel',
        allowed_special_characters: 'Povolené speciální znaky',
    },
    // 匈牙利语
    huHU: {
        serial_no: 'Sorozatszám',
        username: 'Felhasználónév',
        name: 'Név',
        organization: 'Szervezet',
        sex: 'Nem',
        phone_number: 'Telefonszám',
        email: 'E-mail',
        role: 'Szerep',
        login_time: 'Engedélyezési állapot',
        password: 'Jelszó',
        user_edit: 'Felhasználói szerkesztés',
        service_provider_name: 'Szolgáltató neve',
        import_snw_users: 'SNW-felhasználók importálása',
        export_snw_users: 'SNW-felhasználók exportálása',
        brand: 'Márka',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Fájlnév',
        creation_time: 'Létrehozás ideje',
        taskStatus: 'Feladat állapota',
        password_rules: 'Jelszószabályok',
        min_length: 'A jelszó minimális hossza: 8 karakter',
        max_length: 'A jelszó maximális hossza: 20 karakter',
        validity_maxperiod: 'Érvényességi idő: 90 nap',
        require_special_char: 'Tartalmaznia kell legalább egy speciális karaktert',
        require_uppercase: 'Tartalmaznia kell legalább egy nagybetűt',
        require_lowercase: 'Tartalmaznia kell legalább egy kisbetűt',
        require_digit: 'Tartalmaznia kell legalább egy számjegyet',
        no_spaces_allowed: 'Szóközt nem tartalmazhat',
        username_not_allowed: 'Nem tartalmazhatja a felhasználónevet',
        not_match_last_n_passwords: 'Nem egyezhet meg az utolsó 6 jelszó bármelyikével',
        allowed_special_characters: 'Engedélyezett speciális karakterek',
    },
    // 俄罗斯语
    ruRU: {
        serial_no: 'Номер',
        username: 'Имя пользователя',
        name: 'Имя',
        organization: 'Организация',
        sex: 'Пол',
        phone_number: 'Мобильный телефон',
        email: 'Электронная почта',
        role: 'Роль',
        login_time: 'Статус активации',
        password: 'Пароль',
        user_edit: 'Редактирование пользователя',
        service_provider_name: 'Название поставщика услуг',
        import_snw_users: 'Импорт пользователей SNW',
        export_snw_users: 'Экспорт пользователей SNW',
        brand: 'Бренд',
        enable: 'Enable',
        disable: 'Disable',
        userName: 'User Name',
        validity_period: 'Validity Period',
        mailbox_reset: 'Mailbox Reset',
        new_email: 'New Email',
        remaining_validity_period: 'Remaining Validity  Period',
        permanently_valid: 'Permanently Valid',
        fileName: 'Имя файла',
        creation_time: 'Время создания',
        taskStatus: 'Статус задачи',
        password_rules: 'Правила пароля',
        min_length: 'Минимальная длина пароля: 8 символов',
        max_length: 'Максимальная длина пароля: 20 символов',
        validity_maxperiod: 'Срок действия: 90 дней',
        require_special_char: 'Должен содержать хотя бы один специальный символ',
        require_uppercase: 'Должен содержать хотя бы одну заглавную букву',
        require_lowercase: 'Должен содержать хотя бы одну строчную букву',
        require_digit: 'Должен содержать хотя бы одну цифру',
        no_spaces_allowed: 'Пробелы запрещены',
        username_not_allowed: 'Не должен содержать имя пользователя',
        not_match_last_n_passwords: 'Не должен совпадать с любым из последних 6 паролей',
        allowed_special_characters: 'Разрешённые специальные символы',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        serial_no: 'الرقم التسلسلي',
        username: 'اسم المستخدم',
        name: 'الاسم',
        organization: 'المنظمة',
        sex: 'الجنس',
        phone_number: 'رقم الهاتف المحمول',
        email: 'البريد الإلكتروني',
        role: 'الدور',
        login_time: 'حالة التفعيل',
        password: 'كلمة المرور',
        user_edit: 'تحرير المستخدم',
        service_provider_name: 'اسم مزوّد الخدمة',
        import_snw_users: 'استيراد مستخدمي SNW',
        export_snw_users: 'تصدير مستخدمي SNW',
        brand: 'العلامة التجارية',
        enable: 'تفعيل',
        disable: 'تعطيل',
        userName: 'اسم المستخدم',
        validity_period: 'فترة الصلاحية',
        mailbox_reset: 'إعادة تعيين البريد الإلكتروني',
        new_email: 'البريد الإلكتروني الجديد',
        remaining_validity_period: 'فترة الصلاحية المتبقية',
        permanently_valid: 'صالح بشكل دائم',
        fileName: 'اسم الملف',
        creation_time: 'وقت الإنشاء',
        taskStatus: 'حالة المهمة',
        password_rules: 'قواعد كلمة المرور',
        min_length: 'الحد الأدنى لطول كلمة المرور: 8 أحرف',
        max_length: 'الحد الأقصى لطول كلمة المرور: 20 حرفًا',
        validity_maxperiod: 'مدة الصلاحية: 90 يومًا',
        require_special_char: 'يجب أن تحتوي على رمز خاص واحد على الأقل',
        require_uppercase: 'يجب أن تحتوي على حرف كبير واحد على الأقل',
        require_lowercase: 'يجب أن تحتوي على حرف صغير واحد على الأقل',
        require_digit: 'يجب أن تحتوي على رقم واحد على الأقل',
        no_spaces_allowed: 'غير مسموح بوجود مسافات',
        username_not_allowed: 'غير مسموح باحتوائها على اسم المستخدم',
        not_match_last_n_passwords: 'غير مسموح بتكرارها مع آخر 6 كلمات مرور مستخدمة',
        allowed_special_characters: 'الأحرف الخاصة المسموح بها',
    },
    // 保加利亚语
    bgBG: {
        serial_no: 'Пореден номер',
        username: 'Потребителско име',
        name: 'Име',
        organization: 'Организация',
        sex: 'Пол',
        phone_number: 'Мобилен телефон',
        email: 'Имейл',
        role: 'Роля',
        login_time: 'Статус на активиране',
        password: 'Парола',
        user_edit: 'Редактиране на потребител',
        service_provider_name: 'Име на доставчик на услуги',
        import_snw_users: 'Импортиране на SNW потребители',
        export_snw_users: 'Експортиране на SNW потребители',
        brand: 'Марка',
        enable: 'Активиране',
        disable: 'Деактивиране',
        userName: 'Име на потребител',
        validity_period: 'Период на валидност',
        mailbox_reset: 'Нулиране на имейл',
        new_email: 'Нов имейл',
        remaining_validity_period: 'Оставащ период на валидност',
        permanently_valid: 'Винаги валиден',
        fileName: 'Име на файл',
        creation_time: 'Време на създаване',
        taskStatus: 'Статус на задачата',
        password_rules: 'Правила за паролата',
        min_length: 'Минимална дължина на паролата: 8 символа',
        max_length: 'Максимална дължина на паролата: 20 символа',
        validity_maxperiod: 'Валидност: 90 дни',
        require_special_char: 'Трябва да съдържа поне един специален символ',
        require_uppercase: 'Трябва да съдържа поне една главна буква',
        require_lowercase: 'Трябва да съдържа поне една малка буква',
        require_digit: 'Трябва да съдържа поне една цифра',
        no_spaces_allowed: 'Интервали не са разрешени',
        username_not_allowed: 'Не трябва да съдържа потребителското име',
        not_match_last_n_passwords: 'Не трябва да съвпада с нито една от последните 6 пароли',
        allowed_special_characters: 'Разрешени специални символи',
    },
    // 丹麦语
    daDK: {
        serial_no: 'Serienummer',
        username: 'Brugernavn',
        name: 'Navn',
        organization: 'Organisation',
        sex: 'Køn',
        phone_number: 'Mobilnummer',
        email: 'E-mail',
        role: 'Rolle',
        login_time: 'Aktiveringsstatus',
        password: 'Adgangskode',
        user_edit: 'Redigér bruger',
        service_provider_name: 'Navn på serviceudbyder',
        import_snw_users: 'Importér SNW-brugere',
        export_snw_users: 'Eksportér SNW-brugere',
        brand: 'Mærke',
        enable: 'Aktivér',
        disable: 'Deaktivér',
        userName: 'Brugernavn',
        validity_period: 'Gyldighedsperiode',
        mailbox_reset: 'Nulstil e-mail',
        new_email: 'Ny e-mail',
        remaining_validity_period: 'Resterende gyldighedsperiode',
        permanently_valid: 'Permanent gyldig',
        fileName: 'Filnavn',
        creation_time: 'Oprettelsestidspunkt',
        taskStatus: 'Opgavestatus',
        password_rules: 'Adgangskode regler',
        min_length: 'Mindste længde på adgangskode: 8 tegn',
        max_length: 'Maksimal længde på adgangskode: 20 tegn',
        validity_maxperiod: 'Gyldighedsperiode: 90 dage',
        require_special_char: 'Skal indeholde mindst ét specialtegn',
        require_uppercase: 'Skal indeholde mindst ét stort bogstav',
        require_lowercase: 'Skal indeholde mindst ét lille bogstav',
        require_digit: 'Skal indeholde mindst ét tal',
        no_spaces_allowed: 'Mellemrum er ikke tilladt',
        username_not_allowed: 'Må ikke indeholde brugernavnet',
        not_match_last_n_passwords: 'Må ikke være identisk med nogen af de sidste 6 adgangskoder',
        allowed_special_characters: 'Tilladte specialtegn',
    },
    // 芬兰语
    fiFI: {
        serial_no: 'Sarjanumero',
        username: 'Käyttäjätunnus',
        name: 'Nimi',
        organization: 'Organisaatio',
        sex: 'Sukupuoli',
        phone_number: 'Puhelinnumero',
        email: 'Sähköposti',
        role: 'Rooli',
        login_time: 'Käyttötila',
        password: 'Salasana',
        user_edit: 'Muokkaa käyttäjää',
        service_provider_name: 'Palveluntarjoajan nimi',
        import_snw_users: 'Tuo SNW-käyttäjiä',
        export_snw_users: 'Vie SNW-käyttäjiä',
        brand: 'Tuotemerkki',
        enable: 'Ota käyttöön',
        disable: 'Poista käytöstä',
        userName: 'Käyttäjän nimi',
        validity_period: 'Voimassaoloaika',
        mailbox_reset: 'Nollaa sähköpostiosoite',
        new_email: 'Uusi sähköpostiosoite',
        remaining_validity_period: 'Jäljellä oleva voimassaoloaika',
        permanently_valid: 'Pysyvästi voimassa',
        fileName: 'Tiedostonimi',
        creation_time: 'Luontiaika',
        taskStatus: 'Tehtävän tila',
        password_rules: 'Salasanan säännöt',
        min_length: 'Salasanan vähimmäispituus: 8 merkkiä',
        max_length: 'Salasanan enimmäispituus: 20 merkkiä',
        validity_maxperiod: 'Voimassaoloaika: 90 päivää',
        require_special_char: 'Täytyy sisältää vähintään yksi erikoismerkki',
        require_uppercase: 'Täytyy sisältää vähintään yksi iso kirjain',
        require_lowercase: 'Täytyy sisältää vähintään yksi pieni kirjain',
        require_digit: 'Täytyy sisältää vähintään yksi numero',
        no_spaces_allowed: 'Välilyöntejä ei sallita',
        username_not_allowed: 'Ei saa sisältää käyttäjänimeä',
        not_match_last_n_passwords: 'Ei saa olla sama kuin mikään edellisistä 6 salasanasta',
        allowed_special_characters: 'Sallitut erikoismerkit',
    },
    // 繁体中文（台湾）
    zhTW: {
        serial_no: '序號',
        username: '用戶名',
        name: '姓名',
        organization: '組織',
        sex: '性別',
        phone_number: '手機號',
        email: '電子信箱',
        role: '角色',
        login_time: '啟用狀態',
        password: '密碼',
        user_edit: '用戶編輯',
        service_provider_name: '服務商名稱',
        import_snw_users: '匯入 SNW 用戶',
        export_snw_users: '匯出 SNW 用戶',
        brand: '品牌',
        enable: '啟用',
        disable: '停用',
        userName: '用戶姓名',
        validity_period: '有效期',
        mailbox_reset: '重設電子信箱',
        new_email: '新電子信箱',
        remaining_validity_period: '剩餘有效期',
        permanently_valid: '永久有效',
        fileName: '檔案名稱',
        creation_time: '建立時間',
        taskStatus: '任務狀態',
        password_rules: '密碼規則',
        min_length: '密碼最小長度為 8 個字元',
        max_length: '密碼最大長度為 20 個字元',
        validity_maxperiod: '有效期限：90 天',
        require_special_char: '必須包含至少 1 個特殊字元',
        require_uppercase: '必須包含至少 1 個大寫字母',
        require_lowercase: '必須包含至少 1 個小寫字母',
        require_digit: '必須包含至少 1 個數字',
        no_spaces_allowed: '不允許包含空白字元',
        username_not_allowed: '不得包含使用者名稱',
        not_match_last_n_passwords: '不得與前 6 次密碼重複',
        allowed_special_characters: '允許使用的特殊字元',
    },
    // 克罗地亚语
    hrHR: {
        serial_no: 'Serijski broj',
        username: 'Korisničko ime',
        name: 'Ime',
        organization: 'Organizacija',
        sex: 'Spol',
        phone_number: 'Broj mobitela',
        email: 'E-mail',
        role: 'Uloga',
        login_time: 'Status aktivacije',
        password: 'Lozinka',
        user_edit: 'Uređivanje korisnika',
        service_provider_name: 'Naziv pružatelja usluge',
        import_snw_users: 'Uvoz SNW korisnika',
        export_snw_users: 'Izvoz SNW korisnika',
        brand: 'Marka',
        enable: 'Omogući',
        disable: 'Onemogući',
        userName: 'Ime korisnika',
        validity_period: 'Razdoblje važenja',
        mailbox_reset: 'Ponovno postavljanje e-pošte',
        new_email: 'Nova e-pošta',
        remaining_validity_period: 'Preostalo razdoblje važenja',
        permanently_valid: 'Trajno važeće',
        fileName: 'Naziv datoteke',
        creation_time: 'Vrijeme stvaranja',
        taskStatus: 'Status zadatka',
        password_rules: 'Pravila lozinke',
        min_length: 'Minimalna duljina lozinke: 8 znakova',
        max_length: 'Maksimalna duljina lozinke: 20 znakova',
        validity_maxperiod: 'Rok važenja: 90 dana',
        require_special_char: 'Mora sadržavati barem jedan poseban znak',
        require_uppercase: 'Mora sadržavati barem jedno veliko slovo',
        require_lowercase: 'Mora sadržavati barem jedno malo slovo',
        require_digit: 'Mora sadržavati barem jedan broj',
        no_spaces_allowed: 'Razmaci nisu dopušteni',
        username_not_allowed: 'Ne smije sadržavati korisničko ime',
        not_match_last_n_passwords: 'Ne smije se podudarati s bilo kojom od posljednjih 6 lozinki',
        allowed_special_characters: 'Dopušteni posebni znakovi',
    },
    // 拉脱维亚语
    lvLV: {
        serial_no: 'Kārtas numurs',
        username: 'Lietotājvārds',
        name: 'Vārds',
        organization: 'Organizācija',
        sex: 'Dzimums',
        phone_number: 'Tālruņa numurs',
        email: 'E-pasts',
        role: 'Loma',
        login_time: 'Aktivizācijas statuss',
        password: 'Parole',
        user_edit: 'Rediģēt lietotāju',
        service_provider_name: 'Pakalpojumu sniedzēja nosaukums',
        import_snw_users: 'Importēt SNW lietotājus',
        export_snw_users: 'Eksportēt SNW lietotājus',
        brand: 'Zīmols',
        enable: 'Iespējot',
        disable: 'Atspējot',
        userName: 'Lietotāja vārds',
        validity_period: 'Derīguma termiņš',
        mailbox_reset: 'Atiestatīt e-pastu',
        new_email: 'Jauns e-pasts',
        remaining_validity_period: 'Atlikušais derīguma termiņš',
        permanently_valid: 'Pastāvīgi derīgs',
        fileName: 'Faila nosaukums',
        creation_time: 'Izveidošanas laiks',
        taskStatus: 'Uzdevuma statuss',
        password_rules: 'Paroles noteikumi',
        min_length: 'Minimālais paroles garums: 8 rakstzīmes',
        max_length: 'Maksimālais paroles garums: 20 rakstzīmes',
        validity_maxperiod: 'Derīguma termiņš: 90 dienas',
        require_special_char: 'Jāsatur vismaz viena speciāla rakstzīme',
        require_uppercase: 'Jāsatur vismaz viens lielais burts',
        require_lowercase: 'Jāsatur vismaz viens mazais burts',
        require_digit: 'Jāsatur vismaz viens cipars',
        no_spaces_allowed: 'Atstarpes nav atļautas',
        username_not_allowed: 'Nedrīkst saturēt lietotājvārdu',
        not_match_last_n_passwords: 'Nedrīkst sakrist ar jebkuru no pēdējām 6 parolēm',
        allowed_special_characters: 'Atļautās speciālās rakstzīmes',
    },
    // 立陶宛语
    ltLT: {
        serial_no: 'Eilės numeris',
        username: 'Vartotojo vardas',
        name: 'Vardas',
        organization: 'Organizacija',
        sex: 'Lytis',
        phone_number: 'Telefono numeris',
        email: 'El. paštas',
        role: 'Rolė',
        login_time: 'Aktyvinimo būsena',
        password: 'Slaptažodis',
        user_edit: 'Redaguoti vartotoją',
        service_provider_name: 'Paslaugų teikėjo pavadinimas',
        import_snw_users: 'Importuoti SNW vartotojus',
        export_snw_users: 'Eksportuoti SNW vartotojus',
        brand: 'Prekės ženklas',
        enable: 'Įjungti',
        disable: 'Išjungti',
        userName: 'Vartotojo vardas',
        validity_period: 'Galiojimo laikotarpis',
        mailbox_reset: 'Nustatyti el. paštą iš naujo',
        new_email: 'Naujas el. paštas',
        remaining_validity_period: 'Likęs galiojimo laikotarpis',
        permanently_valid: 'Visada galiojantis',
        fileName: 'Failo pavadinimas',
        creation_time: 'Sukūrimo laikas',
        taskStatus: 'Užduoties būsena',
        password_rules: 'Slaptažodžio taisyklės',
        min_length: 'Minimalus slaptažodžio ilgis: 8 simboliai',
        max_length: 'Maksimalus slaptažodžio ilgis: 20 simbolių',
        validity_maxperiod: 'Galiojimo laikas: 90 dienų',
        require_special_char: 'Privalo turėti bent vieną specialųjį simbolį',
        require_uppercase: 'Privalo turėti bent vieną didžiąją raidę',
        require_lowercase: 'Privalo turėti bent vieną mažąją raidę',
        require_digit: 'Privalo turėti bent vieną skaitmenį',
        no_spaces_allowed: 'Tarpai neleidžiami',
        username_not_allowed: 'Negali turėti naudotojo vardo',
        not_match_last_n_passwords: 'Negali sutapti su bet kuriuo iš paskutinių 6 slaptažodžių',
        allowed_special_characters: 'Leidžiami specialieji simboliai',
    },
    // 罗马尼亚语
    roRO: {
        serial_no: 'Nr. crt.',
        username: 'Nume utilizator',
        name: 'Nume',
        organization: 'Organizație',
        sex: 'Sex',
        phone_number: 'Număr de telefon',
        email: 'Email',
        role: 'Rol',
        login_time: 'Stare activare',
        password: 'Parolă',
        user_edit: 'Editare utilizator',
        service_provider_name: 'Nume furnizor de servicii',
        import_snw_users: 'Import utilizatori SNW',
        export_snw_users: 'Export utilizatori SNW',
        brand: 'Marcă',
        enable: 'Activează',
        disable: 'Dezactivează',
        userName: 'Nume utilizator',
        validity_period: 'Perioadă de valabilitate',
        mailbox_reset: 'Resetare email',
        new_email: 'Email nou',
        remaining_validity_period: 'Perioadă rămasă de valabilitate',
        permanently_valid: 'Valabil permanent',
        fileName: 'Nume fișier',
        creation_time: 'Data creării',
        taskStatus: 'Stare sarcină',
        password_rules: 'Reguli parolă',
        min_length: 'Lungime minimă parolă: 8 caractere',
        max_length: 'Lungime maximă parolă: 20 caractere',
        validity_maxperiod: 'Perioadă de valabilitate: 90 de zile',
        require_special_char: 'Trebuie să conțină cel puțin un caracter special',
        require_uppercase: 'Trebuie să conțină cel puțin o literă mare',
        require_lowercase: 'Trebuie să conțină cel puțin o literă mică',
        require_digit: 'Trebuie să conțină cel puțin o cifră',
        no_spaces_allowed: 'Spațiile nu sunt permise',
        username_not_allowed: 'Nu trebuie să conțină numele de utilizator',
        not_match_last_n_passwords:
            'Nu trebuie să se potrivească cu niciuna dintre ultimele 6 parole',
        allowed_special_characters: 'Caractere speciale permise',
    },
    // 挪威博克马尔语
    nbNO: {
        serial_no: 'Serienummer',
        username: 'Brukernavn',
        name: 'Navn',
        organization: 'Organisasjon',
        sex: 'Kjønn',
        phone_number: 'Mobilnummer',
        email: 'E-post',
        role: 'Rolle',
        login_time: 'Aktiveringsstatus',
        password: 'Passord',
        user_edit: 'Rediger bruker',
        service_provider_name: 'Navn på tjenesteleverandør',
        import_snw_users: 'Importer SNW-brukere',
        export_snw_users: 'Eksporter SNW-brukere',
        brand: 'Merkevare',
        enable: 'Aktiver',
        disable: 'Deaktiver',
        userName: 'Brukernavn',
        validity_period: 'Gyldighetsperiode',
        mailbox_reset: 'Tilbakestill e-post',
        new_email: 'Ny e-post',
        remaining_validity_period: 'Gjenstående gyldighetstid',
        permanently_valid: 'Permanent gyldig',
        fileName: 'Filnavn',
        creation_time: 'Opprettelsestidspunkt',
        taskStatus: 'Oppgavestatus',
        password_rules: 'Passordregler',
        min_length: 'Minimumslengde for passord: 8 tegn',
        max_length: 'Maksimumslengde for passord: 20 tegn',
        validity_maxperiod: 'Gyldighetsperiode: 90 dager',
        require_special_char: 'Må inneholde minst ett spesialtegn',
        require_uppercase: 'Må inneholde minst én stor bokstav',
        require_lowercase: 'Må inneholde minst én liten bokstav',
        require_digit: 'Må inneholde minst ett tall',
        no_spaces_allowed: 'Mellomrom er ikke tillatt',
        username_not_allowed: 'Kan ikke inneholde brukernavnet',
        not_match_last_n_passwords: 'Kan ikke være lik noen av de siste 6 passordene',
        allowed_special_characters: 'Tillatte spesialtegn',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        serial_no: 'Nº sequencial',
        username: 'Nome de usuário',
        name: 'Nome',
        organization: 'Organização',
        sex: 'Sexo',
        phone_number: 'Número de celular',
        email: 'E-mail',
        role: 'Função',
        login_time: 'Status de ativação',
        password: 'Senha',
        user_edit: 'Editar usuário',
        service_provider_name: 'Nome do provedor de serviços',
        import_snw_users: 'Importar usuários SNW',
        export_snw_users: 'Exportar usuários SNW',
        brand: 'Marca',
        enable: 'Ativar',
        disable: 'Desativar',
        userName: 'Nome do usuário',
        validity_period: 'Período de validade',
        mailbox_reset: 'Redefinir e-mail',
        new_email: 'Novo e-mail',
        remaining_validity_period: 'Período restante de validade',
        permanently_valid: 'Válido permanentemente',
        fileName: 'Nome do arquivo',
        creation_time: 'Data de criação',
        taskStatus: 'Status da tarefa',
        password_rules: 'Regras da senha',
        min_length: 'Comprimento mínimo da senha: 8 caracteres',
        max_length: 'Comprimento máximo da senha: 20 caracteres',
        validity_maxperiod: 'Validade: 90 dias',
        require_special_char: 'Deve conter pelo menos um caractere especial',
        require_uppercase: 'Deve conter pelo menos uma letra maiúscula',
        require_lowercase: 'Deve conter pelo menos uma letra minúscula',
        require_digit: 'Deve conter pelo menos um dígito',
        no_spaces_allowed: 'Espaços não são permitidos',
        username_not_allowed: 'Não pode conter o nome de usuário',
        not_match_last_n_passwords: 'Não pode ser igual a nenhuma das últimas 6 senhas',
        allowed_special_characters: 'Caracteres especiais permitidos',
    },
    // 瑞典语
    svSE: {
        serial_no: 'Serienummer',
        username: 'Användarnamn',
        name: 'Namn',
        organization: 'Organisation',
        sex: 'Kön',
        phone_number: 'Mobilnummer',
        email: 'E-post',
        role: 'Roll',
        login_time: 'Aktiveringsstatus',
        password: 'Lösenord',
        user_edit: 'Redigera användare',
        service_provider_name: 'Tjänsteleverantörens namn',
        import_snw_users: 'Importera SNW-användare',
        export_snw_users: 'Exportera SNW-användare',
        brand: 'Varumärke',
        enable: 'Aktivera',
        disable: 'Inaktivera',
        userName: 'Användarnamn',
        validity_period: 'Giltighetstid',
        mailbox_reset: 'Återställ e-post',
        new_email: 'Ny e-post',
        remaining_validity_period: 'Återstående giltighetstid',
        permanently_valid: 'Permanent giltig',
        fileName: 'Filnamn',
        creation_time: 'Skapelsedatum',
        taskStatus: 'Uppgiftsstatus',
        password_rules: 'Lösenordsregler',
        min_length: 'Minsta lösenordslängd: 8 tecken',
        max_length: 'Maximal lösenordslängd: 20 tecken',
        validity_maxperiod: 'Giltighetstid: 90 dagar',
        require_special_char: 'Måste innehålla minst ett specialtecken',
        require_uppercase: 'Måste innehålla minst en versal',
        require_lowercase: 'Måste innehålla minst en gemen',
        require_digit: 'Måste innehålla minst en siffra',
        no_spaces_allowed: 'Blanksteg är inte tillåtna',
        username_not_allowed: 'Får inte innehålla användarnamnet',
        not_match_last_n_passwords: 'Får inte matcha något av de senaste 6 lösenorden',
        allowed_special_characters: 'Tillåtna specialtecken',
    },
    // 斯洛伐克语
    skSK: {
        serial_no: 'Poradové číslo',
        username: 'Používateľské meno',
        name: 'Meno',
        organization: 'Organizácia',
        sex: 'Pohlavie',
        phone_number: 'Telefónne číslo',
        email: 'E-mail',
        role: 'Rola',
        login_time: 'Stav povolenia',
        password: 'Heslo',
        user_edit: 'Úprava používateľa',
        service_provider_name: 'Názov poskytovateľa služieb',
        import_snw_users: 'Importovať SNW používateľov',
        export_snw_users: 'Exportovať SNW používateľov',
        brand: 'Značka',
        enable: 'Povoliť',
        disable: 'Zakázať',
        userName: 'Meno používateľa',
        validity_period: 'Platnosť',
        mailbox_reset: 'Obnoviť e-mail',
        new_email: 'Nový e-mail',
        remaining_validity_period: 'Zostávajúca platnosť',
        permanently_valid: 'Trvalo platné',
        fileName: 'Názov súboru',
        creation_time: 'Čas vytvorenia',
        taskStatus: 'Stav úlohy',
        password_rules: 'Pravidlá hesla',
        min_length: 'Minimálna dĺžka hesla: 8 znakov',
        max_length: 'Maximálna dĺžka hesla: 20 znakov',
        validity_maxperiod: 'Platnosť: 90 dní',
        require_special_char: 'Musí obsahovať aspoň jeden špeciálny znak',
        require_uppercase: 'Musí obsahovať aspoň jedno veľké písmeno',
        require_lowercase: 'Musí obsahovať aspoň jedno malé písmeno',
        require_digit: 'Musí obsahovať aspoň jednu číslicu',
        no_spaces_allowed: 'Medzery nie sú povolené',
        username_not_allowed: 'Nesmie obsahovať používateľské meno',
        not_match_last_n_passwords: 'Nesmie byť rovnaké ako ktorékoľvek z posledných 6 hesiel',
        allowed_special_characters: 'Povolené špeciálne znaky',
    },
    // 斯洛文尼亚语
    slSI: {
        serial_no: 'Zaporedna številka',
        username: 'Uporabniško ime',
        name: 'Ime',
        organization: 'Organizacija',
        sex: 'Spol',
        phone_number: 'Telefonska številka',
        email: 'E-naslov',
        role: 'Vloga',
        login_time: 'Stanje omogočanja',
        password: 'Geslo',
        user_edit: 'Urejanje uporabnika',
        service_provider_name: 'Ime ponudnika storitev',
        import_snw_users: 'Uvozi SNW uporabnike',
        export_snw_users: 'Izvozi SNW uporabnike',
        brand: 'Blagovna znamka',
        enable: 'Omogoči',
        disable: 'Onemogoči',
        userName: 'Ime uporabnika',
        validity_period: 'Veljavnost',
        mailbox_reset: 'Ponastavi e-naslov',
        new_email: 'Nov e-naslov',
        remaining_validity_period: 'Preostala veljavnost',
        permanently_valid: 'Trajno veljavno',
        fileName: 'Ime datoteke',
        creation_time: 'Čas ustvarjanja',
        taskStatus: 'Stanje opravila',
        password_rules: 'Pravila za geslo',
        min_length: 'Najmanjša dolžina gesla: 8 znakov',
        max_length: 'Največja dolžina gesla: 20 znakov',
        validity_maxperiod: 'Veljavnost: 90 dni',
        require_special_char: 'Mora vsebovati vsaj en poseben znak',
        require_uppercase: 'Mora vsebovati vsaj eno veliko črko',
        require_lowercase: 'Mora vsebovati vsaj eno malo črko',
        require_digit: 'Mora vsebovati vsaj eno številko',
        no_spaces_allowed: 'Presledki niso dovoljeni',
        username_not_allowed: 'Ne sme vsebovati uporabniškega imena',
        not_match_last_n_passwords: 'Ne sme biti enako kot katero od zadnjih 6 gesel',
        allowed_special_characters: 'Dovoljeni posebni znaki',
    },
    // 泰语
    thTH: {
        serial_no: 'ลำดับที่',
        username: 'ชื่อผู้ใช้',
        name: 'ชื่อ',
        organization: 'องค์กร',
        sex: 'เพศ',
        phone_number: 'เบอร์โทรศัพท์มือถือ',
        email: 'อีเมล',
        role: 'บทบาท',
        login_time: 'สถานะการเปิดใช้งาน',
        password: 'รหัสผ่าน',
        user_edit: 'แก้ไขผู้ใช้',
        service_provider_name: 'ชื่อผู้ให้บริการ',
        import_snw_users: 'นำเข้าผู้ใช้ SNW',
        export_snw_users: 'ส่งออกผู้ใช้ SNW',
        brand: 'แบรนด์',
        enable: 'เปิดใช้งาน',
        disable: 'ปิดใช้งาน',
        userName: 'ชื่อผู้ใช้',
        validity_period: 'ระยะเวลาใช้งาน',
        mailbox_reset: 'รีเซ็ตอีเมล',
        new_email: 'อีเมลใหม่',
        remaining_validity_period: 'ระยะเวลาใช้งานที่เหลือ',
        permanently_valid: 'ใช้งานได้ตลอด',
        fileName: 'ชื่อไฟล์',
        creation_time: 'เวลาสร้าง',
        taskStatus: 'สถานะงาน',
        password_rules: 'กฎรหัสผ่าน',
        min_length: 'ความยาวขั้นต่ำของรหัสผ่าน: 8 ตัวอักษร',
        max_length: 'ความยาวสูงสุดของรหัสผ่าน: 20 ตัวอักษร',
        validity_maxperiod: 'อายุการใช้งาน: 90 วัน',
        require_special_char: 'ต้องมีอักขระพิเศษอย่างน้อย 1 ตัว',
        require_uppercase: 'ต้องมีตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัว',
        require_lowercase: 'ต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว',
        require_digit: 'ต้องมีตัวเลขอย่างน้อย 1 ตัว',
        no_spaces_allowed: 'ไม่อนุญาตให้มีช่องว่าง',
        username_not_allowed: 'ห้ามมีชื่อผู้ใช้',
        not_match_last_n_passwords: 'ห้ามซ้ำกับรหัสผ่าน 6 ครั้งก่อนหน้า',
        allowed_special_characters: 'อักขระพิเศษที่อนุญาต',
    },
    // 乌克兰语
    ukUA: {
        serial_no: 'Порядковий номер',
        username: 'Ім\'я користувача',
        name: 'Ім\'я',
        organization: 'Організація',
        sex: 'Стать',
        phone_number: 'Номер мобільного',
        email: 'Електронна пошта',
        role: 'Роль',
        login_time: 'Стан активації',
        password: 'Пароль',
        user_edit: 'Редагувати користувача',
        service_provider_name: 'Назва постачальника послуг',
        import_snw_users: 'Імпорт користувачів SNW',
        export_snw_users: 'Експорт користувачів SNW',
        brand: 'Бренд',
        enable: 'Увімкнути',
        disable: 'Вимкнути',
        userName: 'Ім\'я користувача',
        validity_period: 'Термін дії',
        mailbox_reset: 'Скинути пошту',
        new_email: 'Нова електронна пошта',
        remaining_validity_period: 'Залишок терміну дії',
        permanently_valid: 'Завжди дійсний',
        fileName: 'Назва файлу',
        creation_time: 'Час створення',
        taskStatus: 'Статус завдання',
        password_rules: 'Правила пароля',
        min_length: 'Мінімальна довжина пароля: 8 символів',
        max_length: 'Максимальна довжина пароля: 20 символів',
        validity_maxperiod: 'Термін дії: 90 днів',
        require_special_char: 'Повинен містити принаймні один спеціальний символ',
        require_uppercase: 'Повинен містити принаймні одну велику літеру',
        require_lowercase: 'Повинен містити принаймні одну малу літеру',
        require_digit: 'Повинен містити принаймні одну цифру',
        no_spaces_allowed: 'Пробіли заборонені',
        username_not_allowed: 'Не повинен містити ім’я користувача',
        not_match_last_n_passwords: 'Не повинен збігатися з будь-яким із останніх 6 паролів',
        allowed_special_characters: 'Дозволені спеціальні символи',
    },
    // 希腊语
    elGR: {
        serial_no: 'Α/Α',
        username: 'Όνομα χρήστη',
        name: 'Όνομα',
        organization: 'Οργανισμός',
        sex: 'Φύλο',
        phone_number: 'Αριθμός κινητού',
        email: 'Ηλεκτρονικό ταχυδρομείο',
        role: 'Ρόλος',
        login_time: 'Κατάσταση ενεργοποίησης',
        password: 'Κωδικός πρόσβασης',
        user_edit: 'Επεξεργασία χρήστη',
        service_provider_name: 'Όνομα παρόχου υπηρεσιών',
        import_snw_users: 'Εισαγωγή χρηστών SNW',
        export_snw_users: 'Εξαγωγή χρηστών SNW',
        brand: 'Μάρκα',
        enable: 'Ενεργοποίηση',
        disable: 'Απενεργοποίηση',
        userName: 'Όνομα χρήστη',
        validity_period: 'Περίοδος ισχύος',
        mailbox_reset: 'Επαναφορά email',
        new_email: 'Νέο email',
        remaining_validity_period: 'Υπόλοιπη περίοδος ισχύος',
        permanently_valid: 'Μόνιμα έγκυρο',
        fileName: 'Όνομα αρχείου',
        creation_time: 'Ώρα δημιουργίας',
        taskStatus: 'Κατάσταση εργασίας',
        password_rules: 'Κανόνες κωδικού πρόσβασης',
        min_length: 'Ελάχιστο μήκος κωδικού: 8 χαρακτήρες',
        max_length: 'Μέγιστο μήκος κωδικού: 20 χαρακτήρες',
        validity_maxperiod: 'Περίοδος ισχύος: 90 ημέρες',
        require_special_char: 'Πρέπει να περιέχει τουλάχιστον έναν ειδικό χαρακτήρα',
        require_uppercase: 'Πρέπει να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα',
        require_lowercase: 'Πρέπει να περιέχει τουλάχιστον ένα πεζό γράμμα',
        require_digit: 'Πρέπει να περιέχει τουλάχιστον ένα ψηφίο',
        no_spaces_allowed: 'Δεν επιτρέπονται κενά',
        username_not_allowed: 'Δεν πρέπει να περιέχει το όνομα χρήστη',
        not_match_last_n_passwords:
            'Δεν πρέπει να ταιριάζει με κανέναν από τους τελευταίους 6 κωδικούς',
        allowed_special_characters: 'Επιτρεπόμενοι ειδικοί χαρακτήρες',
    },
    // 爱沙尼亚语
    etEE: {
        serial_no: 'Järjekorranumber',
        username: 'Kasutajanimi',
        name: 'Nimi',
        organization: 'Organisatsioon',
        sex: 'Sugu',
        phone_number: 'Telefoninumber',
        email: 'E-post',
        role: 'Roll',
        login_time: 'Luba olek',
        password: 'Parool',
        user_edit: 'Muuda kasutajat',
        service_provider_name: 'Teenusepakkuja nimi',
        import_snw_users: 'Impordi SNW kasutajaid',
        export_snw_users: 'Ekspordi SNW kasutajaid',
        brand: 'Bränd',
        enable: 'Luba',
        disable: 'Keela',
        userName: 'Kasutaja nimi',
        validity_period: 'Kehtivusaeg',
        mailbox_reset: 'E-posti lähtestamine',
        new_email: 'Uus e-post',
        remaining_validity_period: 'Järelejäänud kehtivusaeg',
        permanently_valid: 'Alati kehtiv',
        fileName: 'Faili nimi',
        creation_time: 'Loomise aeg',
        taskStatus: 'Ülesande staatus',
        password_rules: 'Parooli reeglid',
        min_length: 'Parooli minimaalne pikkus: 8 tähemärki',
        max_length: 'Parooli maksimaalne pikkus: 20 tähemärki',
        validity_maxperiod: 'Kehtivusaeg: 90 päeva',
        require_special_char: 'Peab sisaldama vähemalt ühte erimärki',
        require_uppercase: 'Peab sisaldama vähemalt ühte suurt tähte',
        require_lowercase: 'Peab sisaldama vähemalt ühte väikest tähte',
        require_digit: 'Peab sisaldama vähemalt ühte numbrit',
        no_spaces_allowed: 'Tühikud pole lubatud',
        username_not_allowed: 'Ei tohi sisaldada kasutajanime',
        not_match_last_n_passwords: 'Ei tohi kattuda ühegi viimase 6 parooliga',
        allowed_special_characters: 'Lubatud erimärgid',
    },
    // 哈萨克语
    kkKZ: {
        serial_no: 'Реттік нөмір',
        username: 'Пайдаланушы аты',
        name: 'Аты',
        organization: 'Ұйым',
        sex: 'Жынысы',
        phone_number: 'Мобильді нөмір',
        email: 'Электрондық пошта',
        role: 'Рөл',
        login_time: 'Қосу күйі',
        password: 'Құпия сөз',
        user_edit: 'Пайдаланушыны түзету',
        service_provider_name: 'Қызмет көрсетушінің атауы',
        import_snw_users: 'SNW пайдаланушыларын импорттау',
        export_snw_users: 'SNW пайдаланушыларын экспорттау',
        brand: 'Бренд',
        enable: 'Қосу',
        disable: 'Өшіру',
        userName: 'Пайдаланушының аты',
        validity_period: 'Жарамдылық мерзімі',
        mailbox_reset: 'Поштаны қайта орнату',
        new_email: 'Жаңа пошта',
        remaining_validity_period: 'Қалған жарамдылық мерзімі',
        permanently_valid: 'Тұрақты жарамды',
        fileName: 'Файл атауы',
        creation_time: 'Құрылған уақыты',
        taskStatus: 'Тапсырма күйі',
        password_rules: 'Құпия сөз ережелері',
        min_length: 'Құпия сөздің минималды ұзындығы: 8 таңба',
        max_length: 'Құпия сөздің максималды ұзындығы: 20 таңба',
        validity_maxperiod: 'Жарамдылық мерзімі: 90 күн',
        require_special_char: 'Кем дегенде бір арнайы таңба болуы керек',
        require_uppercase: 'Кем дегенде бір үлкен әріп болуы керек',
        require_lowercase: 'Кем дегенде бір кіші әріп болуы керек',
        require_digit: 'Кем дегенде бір цифр болуы керек',
        no_spaces_allowed: 'Бос орындарға рұқсат етілмейді',
        username_not_allowed: 'Пайдаланушы атын қамтуға болмайды',
        not_match_last_n_passwords: 'Соңғы 6 құпия сөзден ешбіріне сәйкес келмеуі керек',
        allowed_special_characters: 'Рұқсат етілген арнайы таңбалар',
    },
    // 希伯来语
    heIL: {
        serial_no: 'מס\' סידורי',
        username: 'שם משתמש',
        name: 'שם',
        organization: 'ארגון',
        sex: 'מין',
        phone_number: 'מספר נייד',
        email: 'דוא"ל',
        role: 'תפקיד',
        login_time: 'סטטוס הפעלה',
        password: 'סיסמה',
        user_edit: 'עריכת משתמש',
        service_provider_name: 'שם ספק השירות',
        import_snw_users: 'ייבוא משתמשי SNW',
        export_snw_users: 'ייצוא משתמשי SNW',
        brand: 'מותג',
        enable: 'הפעל',
        disable: 'נטרל',
        userName: 'שם המשתמש',
        validity_period: 'תקופת תוקף',
        mailbox_reset: 'איפוס תיבת דואר',
        new_email: 'דוא"ל חדש',
        remaining_validity_period: 'יתרת תקופת תוקף',
        permanently_valid: 'בתוקף לצמיתות',
        fileName: 'שם קובץ',
        creation_time: 'תאריך יצירה',
        taskStatus: 'סטטוס משימה',
        password_rules: 'כללי סיסמה',
        min_length: 'אורך מינימלי של הסיסמה: 8 תווים',
        max_length: 'אורך מקסימלי של הסיסמה: 20 תווים',
        validity_maxperiod: 'תוקף: 90 ימים',
        require_special_char: 'חייב להכיל תו מיוחד אחד לפחות',
        require_uppercase: 'חייב להכיל אות גדולה אחת לפחות',
        require_lowercase: 'חייב להכיל אות קטנה אחת לפחות',
        require_digit: 'חייב להכיל ספרה אחת לפחות',
        no_spaces_allowed: 'רווחים אסורים',
        username_not_allowed: 'אסור לכלול את שם המשתמש',
        not_match_last_n_passwords: 'אסור להתאים לאף אחת מהסיסמאות האחרונות (6)',
        allowed_special_characters: 'תווים מיוחדים מותרים',
    },
};
